// Read-only projection: physical places are resolved only by explicit scene associations.
export function dayLocationSummary(entries = [], sceneByUid = new Map(), locations = [], draftLocations = []) {
  const groups = [];
  const byKey = new Map();
  const add = (place, key, entry) => {
    let group = byKey.get(key);
    if (!group) {
      group = { key, name: place?.name?.trim() || null, scenes: [] };
      byKey.set(key, group); groups.push(group);
    }
    if (entry) {
      const scene = sceneByUid.get(entry.sceneUid);
      group.scenes.push({ occurrenceId: entry.id, sceneUid: entry.sceneUid, number: scene?.number ?? '?', heading: scene?.heading || entry.name || 'Scene heading unavailable' });
    }
  };
  for (const entry of entries) {
    if (entry.kind !== 'scene') continue;
    const draft = draftLocations.filter(l => l.sceneUids?.includes(entry.sceneUid));
    const assigned = (draft.length ? draft : locations.filter(l => l.sceneUids?.includes(entry.sceneUid)));
    if (!assigned.length) add(null, 'unassigned', entry);
    for (const place of assigned) {
      const key = place.locationId || place.id || `place:${locations.includes(place) ? locations.indexOf(place) : `draft:${draftLocations.indexOf(place)}`}`;
      add(place, key, entry);
    }
  }
  return groups;
}